import React from 'react';
import pt from 'prop-types';

import { classNames, singularize } from 'utils';

import Button from 'components/button';
import ButtonLink from 'components/button/link';

import './collection.scss';

const VOWELS = ['a', 'e', 'i', 'o', 'u'];

export default class CollectionEmpty extends React.PureComponent {
  static propTypes = {
    uri: pt.string,
    title: pt.string,
    emptyTitle: pt.oneOfType([pt.string, pt.bool]),
    emptyAction: pt.oneOfType([pt.string, pt.bool]),
    emptyActionLink: pt.string,
    emptyActionTarget: pt.string,
    emptyActionSize: pt.string,
    emptyDescription: pt.oneOfType([pt.node, pt.bool]),
    emptySecondAction: pt.string,
    emptySecondActionLink: pt.string,
    emptySecondActionTarget: pt.string,
    className: pt.string,
    renderEmpty: pt.func,
    onClickAction: pt.func,
  };

  getLinkToViewNew() {
    const { uri, currentView } = this.props;

    if (currentView) {
      const action = currentView.actions?.find((action) => action.id === 'new');

      if (action?.link) {
        const link = { url: action.link };

        if (action.target && action.target !== 'self') {
          link.target = action.target;
        }

        return link;
      }
    }

    return { url: `${uri}/new` };
  }

  render() {
    const {
      title = 'things',
      emptyTitle,
      emptyAction,
      emptyActionSize = 'md',
      emptyDescription,
      emptySecondAction,
      emptySecondActionLink,
      emptySecondActionTarget,
      renderEmpty,
      onClickAction,
      onClickSecondAction,
      className,
    } = this.props;

    if (renderEmpty) {
      return renderEmpty(this.props);
    }

    let { emptyActionLink, emptyActionTarget } = this.props;

    if (emptyAction !== false && !onClickAction && !emptyActionLink) {
      const link = this.getLinkToViewNew();

      emptyActionLink = link.url;
      emptyActionTarget = link.target;
    }

    const actionLabel = emptyAction
      ? emptyAction
      : getDefaultActionLabel(title);

    return (
      <div className={classNames('collection-empty', className)}>
        <div className="collection-empty-container">
          <div className="collection-empty-inner">
            {emptyTitle !== false && (
              <h2>
                {emptyTitle ||
                  (emptyDescription
                    ? `Create your first ${singularize(title).toLowerCase()}`
                    : `No ${title.toLowerCase()} yet`)}
              </h2>
            )}

            {emptyDescription !== false && (
              <div className="collection-empty-desc">
                {emptyDescription ||
                  `Get started by adding your first ${singularize(
                    title,
                  ).toLowerCase()}`}
              </div>
            )}

            {emptyAction !== false && (
              <div className="collection-empty-action">
                {onClickAction ? (
                  <Button onClick={onClickAction} size={emptyActionSize}>
                    {actionLabel}
                  </Button>
                ) : (
                  <ButtonLink
                    to={emptyActionLink}
                    target={emptyActionTarget}
                    size={emptyActionSize}
                  >
                    {actionLabel}
                  </ButtonLink>
                )}

                {emptySecondAction && (
                  <ButtonLink
                    to={emptySecondActionLink}
                    target={emptySecondActionTarget}
                    type="secondary"
                    size={emptyActionSize}
                    onClick={onClickSecondAction}
                  >
                    {emptySecondAction}
                  </ButtonLink>
                )}
              </div>
            )}
          </div>

          <div className="collection-empty-image" />
        </div>
      </div>
    );
  }
}

function getDefaultActionLabel(title) {
  const object = singularize(title).toLowerCase();
  const article = VOWELS.includes(object[0].toLowerCase()) ? 'an' : 'a';
  return `Create ${article} ${object}`;
}
